var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('w-input',{attrs:{"model":_vm.schema.listNumber}})],1),_c('div',{staticClass:"col"},[_c('w-datepicker',{attrs:{"model":_vm.schema.documentDate}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }